import secureLocalStorage from "react-secure-storage";
import { fetchSignedInUser } from "../Api/index";

// Same rule as the rest of this app for who may use it
const canUseThisApp = (results) => results.assets !== "Restricted";

// Signed in to another app already? Save that login here the way signing in
// does and reload, so the app starts as that user. Resolves false when there
// is no shared login or this user may not use this app, so the caller can
// show the login form.
export async function pickUpSharedLogin() {
  try {
    const { data } = await fetchSignedInUser();
    if (!data?.results || !canUseThisApp(data.results)) return false;
    secureLocalStorage.setItem("profile", JSON.stringify(data));
    window.location.reload();
    return true;
  } catch {
    return false;
  }
}
